import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormat'
})
export class DurationFormatPipe implements PipeTransform {

   transform(value: string): string {
    if (!value) return '';

    const [horaStr, minutoStr, segundoStr] = value.split(':');

    const horas = parseInt(horaStr, 10);
    const minutos = parseInt(minutoStr, 10);
    const segundos = parseInt(segundoStr, 10);

    if (horas > 0) {
      const horasFmt = horas < 10 ? horas.toString() : this.pad(horas);
      return `${horasFmt}h: ${this.pad(minutos)}m`;
    } else {
      return `${this.pad(minutos)}m: ${this.pad(segundos)}s`;
    }

  }

  private pad(num: number): string {
    return num.toString().padStart(2, '0');
  }

}
